/**
 *
 * @param {number} num
 * @returns {string}
 */
const pad2 = num => (num < 10 ? "0" : "") + num;

export const formatTime = time => `${pad2(time[0])}:${pad2(time[1])}`;

/**
 *
 * @param {[number, number]} time
 * @param {number} timeStep
 * @returns {[number, number]}
 */
export const addTime = (time, timeStep) => {
  const newMinutes = time[1] + timeStep;
  return [time[0] + (newMinutes >= 60 ? 1 : 0), newMinutes % 60];
};

/**
 *
 * @param {[number, number]} time1
 * @param {[number, number]} time2
 * @returns {-1 | 0 | 1}
 */
export const cmpTime = (time1, time2) => {
  return time1[0] < time2[0]
    ? -1
    : time1[0] > time2[0]
    ? 1
    : time1[1] < time2[1]
    ? -1
    : time1[1] > time2[1]
    ? 1
    : 0;
};

/**
 *
 * @param {[number, number]} minTime
 * @param {[number, number]} maxTime
 * @param {number} timeStep
 */
export const computeTimeRange = (minTime, maxTime, timeStep) => {
  return cmpTime(minTime, maxTime) > 0
    ? []
    : [minTime].concat(
        computeTimeRange(addTime(minTime, timeStep), maxTime, timeStep)
      );
};
